import { ComponentsModule } from 'src/app/components/components.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AddressDetailPageRoutingModule } from './address-detail-routing.module';

import { AddressDetailPage } from './address-detail.page';
import { IonicSelectableModule } from 'ionic-selectable';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    AddressDetailPageRoutingModule,
    IonicSelectableModule,
    ComponentsModule,
    NzAutocompleteModule,
    TranslateModule,
  ],
  declarations: [AddressDetailPage],
})
export class AddressDetailPageModule {}
